import { Header, HeaderLogoWithName } from 'components'
import { BackToMenu, NavMenu } from 'components/buttons'

const HeaderCheckout = ({ maxWidth = '100%' }: { maxWidth?: string }) => {
  return (
    <Header
      maxWidth={maxWidth}
      title={<HeaderLogoWithName />}
      left={<BackToMenu />}
      right={<NavMenu />}
    />
  )
}

export default HeaderCheckout
